import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApprovalFlowRequest } from 'src/app/models/interface/CAM/approval-management';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { ApprovalManagementService } from 'src/app/services/dataLayer/CAM/approval-management.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ApprovalContentService } from '../../services/approval-content.service';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
  selector: 'app-approvalflow-form',
  templateUrl: './approvalflow-form.component.html',
  styleUrls: ['./approvalflow-form.component.scss'],
  imports: [ReactiveFormsModule, MatRadioGroup, MatRadioButton, MatFormField, MatLabel, MatIcon, MatSuffix, MatSelect, NgFor, MatOption, NgIf, MatError, MatButton, MatIconButton, MatInput, MatAutocomplete, MatAutocompleteTrigger]
})
export class ApprovalflowFormComponent implements OnInit, OnDestroy {

  approvalflowForm: FormGroup;
  receivedData: any;
  selectedApproverCount: number = 3; // Default value
  approverCounts: number[] = [1, 2, 3]; // Available options for total approvers
  productType: any;
  appliedOn: any;
  CorporateUsers: any[] = [];
  CorporateUsersList: any[] = []
  sauserId!: string;
  noItemFound: string = '';
  approvalList: any;
  private debounceTimer: any;
  private destroy$ = new Subject<void>();
  content: any;

  // Search Controls
  inPolicyApproverIDL1SearchControl = new FormControl('');
  inPolicyApproverIDL2SearchControl = new FormControl('');
  inPolicyApproverIDL3SearchControl = new FormControl('');
  outPolicyApproverIDL1SearchControl = new FormControl('');
  outPolicyApproverIDL2SearchControl = new FormControl('');
  outPolicyApprover_DL3SearchControl = new FormControl('');
  dictionaryContent:any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _CamService: CamService,
    private crypto: CryptoService,
    private _ToastrApiService: ToastrApiService,
    private _CompanyManagementService: CompanyManagementService,
    private _ApprovalManagementService: ApprovalManagementService,
    private contentService: ApprovalContentService,
    private readonly dictionaryContentService: DisctionaryContent
  ) {

    this.approvalflowForm = this.fb.group({
      flag: ['ADD'],
      workFlowID: [null],
      sauerid: [this.crypto.getValueFromKey('USERID') as string],
      approvalFlow: ['EIT', [Validators.required]],
      totalApprovals: [3, [Validators.required]],
      inPolicyApproverIDL1: [null],
      inPolicyApproverIDL2: [null],
      inPolicyApproverIDL3: [null],
      outPolicyApproverIDL1: [null],
      outPolicyApproverIDL2: [null],
      outPolicyApprover_DL3: [null],

      productType: ['', [Validators.required]],
      travelCategory: ['', [Validators.required]],
      workFlowAppliedOn: ['', [Validators.required]],
      appliedForID: ['', [Validators.required]]

    });


  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    });
    this.sauserId = this.crypto.getValueFromKey('USERID') as string
    this.receivedData = this._CamService.approvalWorkFlowSettingFormData;

    //GTM use
    this._ApprovalManagementService.$approvalList.subscribe((result) => {
      this.approvalList = result
    })
    this._ApprovalManagementService.page_landing(' Approval Management - Approval flow settings', this.approvalList?.length, 'Approval Management Workflow') //GTM use

    if (!!this.receivedData) {
      this.productType = this.receivedData.form.productType;
      this.appliedOn = this.receivedData.form.workFlowAppliedOn;
      this.approvalflowForm.patchValue(this._CamService.approvalWorkFlowSettingFormData.form);

      const approver = this._CamService.approvalWorkFlowSettingFormData.lists


      this.CorporateUsers = [
        { userName: approver?.inPolicyApproverName1, saUserId: approver?.inPolicyApproverIdL1, employeeCode: approver?.inPolicyApproverCode1 },
        { userName: approver?.inPolicyApproverName2, saUserId: approver?.inPolicyApproverIdL2, employeeCode: approver?.inPolicyApproverCode2 },
        { userName: approver?.inPolicyApproverName3, saUserId: approver?.inPolicyApproverIdL3, employeeCode: approver?.inPolicyApproverCode3 },
        { userName: approver?.outPolicyApproverName1, saUserId: approver?.outPolicyApproverIdL1, employeeCode: approver?.outPolicyApproverCode1 },
        { userName: approver?.outPolicyApproverName2, saUserId: approver?.outPolicyApproverIdL2, employeeCode: approver?.outPolicyApproverCode2 },
        { userName: approver?.outPolicyApproverName3, saUserId: approver?.outPolicyApproverIdL3, employeeCode: approver?.outPolicyApproverCode3 }


      ]
      // Map the IDs to user objects
      //   
      const formData = { ...this._CamService.approvalWorkFlowSettingFormData.form };
      this.selectedApproverCount = Number(formData.totalApprovals);
      this.onApproverCountChange(this.selectedApproverCount);
      // Now patch the complete form
      // this.approvalflowForm.patchValue(formData)
      this.onApproverCountChange(Number(this._CamService.approvalWorkFlowSettingFormData.form.totalApprovals))

      // Initialize search controls
      this.updateSearchDisplays();
    } else {
      this.onApproverCountChange(3)
    }

    this.approvalflowForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (this._CamService.approvalWorkFlowSettingFormData && this._CamService.approvalWorkFlowSettingFormData.form) {
        this._CamService.approvalWorkFlowSettingFormData.form = {
          ...this._CamService.approvalWorkFlowSettingFormData.form,
          ...val
        };
      }
    });

  }

  private updateSearchDisplays() {
    const approver = this.receivedData?.lists;
    if (!approver) return;
    this.inPolicyApproverIDL1SearchControl.setValue(approver.inPolicyApproverName1 || '', { emitEvent: false });
    this.inPolicyApproverIDL2SearchControl.setValue(approver.inPolicyApproverName2 || '', { emitEvent: false });
    this.inPolicyApproverIDL3SearchControl.setValue(approver.inPolicyApproverName3 || '', { emitEvent: false });
    this.outPolicyApproverIDL1SearchControl.setValue(approver.outPolicyApproverName1 || '', { emitEvent: false });
    this.outPolicyApproverIDL2SearchControl.setValue(approver.outPolicyApproverName2 || '', { emitEvent: false });
    this.outPolicyApprover_DL3SearchControl.setValue(approver.outPolicyApproverName3 || '', { emitEvent: false });
  }

  // Function to handle changes in the "Total approver" dropdown
  onApproverCountChange(count: number) {
    this.selectedApproverCount = count; // Convert string to number if needed
    // Clear all required validators first
    this.approvalflowForm.get('inPolicyApproverIDL1')?.clearValidators();
    this.approvalflowForm.get('inPolicyApproverIDL2')?.clearValidators();
    this.approvalflowForm.get('inPolicyApproverIDL3')?.clearValidators();
    this.approvalflowForm.get('outPolicyApproverIDL1')?.clearValidators();
    this.approvalflowForm.get('outPolicyApproverIDL2')?.clearValidators();
    this.approvalflowForm.get('outPolicyApprover_DL3')?.clearValidators();


    if (count < 3) {
      this.approvalflowForm.get('inPolicyApproverIDL3')?.setValue(null);
      this.approvalflowForm.get('outPolicyApprover_DL3')?.setValue(null);
    }
    if (count < 2) {
      this.approvalflowForm.get('inPolicyApproverIDL2')?.setValue(null);
      this.approvalflowForm.get('outPolicyApproverIDL2')?.setValue(null);
    }

    // Add required validators based on selected count
    if (this.selectedApproverCount >= 1) {
      this.approvalflowForm.get('inPolicyApproverIDL1')?.setValidators([Validators.required]);
      this.approvalflowForm.get('outPolicyApproverIDL1')?.setValidators([Validators.required]);
    }
    if (this.selectedApproverCount >= 2) {
      this.approvalflowForm.get('inPolicyApproverIDL2')?.setValidators([Validators.required]);
      this.approvalflowForm.get('outPolicyApproverIDL2')?.setValidators([Validators.required]);
    }
    if (this.selectedApproverCount >= 3) {
      this.approvalflowForm.get('inPolicyApproverIDL3')?.setValidators([Validators.required]);
      this.approvalflowForm.get('outPolicyApprover_DL3')?.setValidators([Validators.required]);
    }

    // Update validity
    this.approvalflowForm.get('inPolicyApproverIDL1')?.updateValueAndValidity();
    this.approvalflowForm.get('inPolicyApproverIDL2')?.updateValueAndValidity();
    this.approvalflowForm.get('inPolicyApproverIDL3')?.updateValueAndValidity();
    this.approvalflowForm.get('outPolicyApproverIDL1')?.updateValueAndValidity();
    this.approvalflowForm.get('outPolicyApproverIDL2')?.updateValueAndValidity();
    this.approvalflowForm.get('outPolicyApprover_DL3')?.updateValueAndValidity();
  }


  onCancel() {
    this._CamService.approvalWorkFlowSettingFormData = null;
    this._ApprovalManagementService.approval_flow_cancel('Cancel')//GTM use
    this.router.navigate(['/cam/approval-management/approval-listing']);
  }


  inpolicyInputList(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const formControlName = (event.target as HTMLInputElement).getAttribute('data-control-name');

    if (!value || value.trim() === '') {
      if (formControlName) {
        this.approvalflowForm.get(formControlName)?.setValue(null);
        this.approvalflowForm.get(formControlName)?.markAsDirty();
      }
    }

    clearTimeout(this.debounceTimer);   // clear previous timer
    this.debounceTimer = setTimeout(() => {
      this.fetchApprover(value);       // call API after delay
    }, 400);
    // 400ms debounce
  }

  onApproverSelected(controlName: string, searchControl: FormControl, event: MatAutocompleteSelectedEvent) {
    const user = event.option.value;
    this.approvalflowForm.get(controlName)?.setValue(user?.saUserId ?? null);
    this.approvalflowForm.get(controlName)?.markAsDirty();
    searchControl.setValue(user?.userName ?? '', { emitEvent: false });
    this.saveApproverNameToFormData(controlName, user?.userName ?? '', user?.employeeCode, user?.saUserId);
  }

  clearApprover(controlName: string, searchControl: FormControl, event: Event) {
    event.stopPropagation();
    this.approvalflowForm.get(controlName)?.setValue(null);
    this.approvalflowForm.get(controlName)?.markAsDirty();
    searchControl.setValue('');
    this.saveApproverNameToFormData(controlName, '', '', '');
    // Optionally trigger a fetch to show default list
    this.fetchApprover('');
  }

  private saveApproverNameToFormData(controlName: string, userName: string, userCode?: string, userId?: string) {
    if (!this._CamService.approvalWorkFlowSettingFormData) {
      this._CamService.approvalWorkFlowSettingFormData = { form: {}, lists: {} };
    }
    if (!this._CamService.approvalWorkFlowSettingFormData.lists) {
      this._CamService.approvalWorkFlowSettingFormData.lists = {};
    }
    const lists = this._CamService.approvalWorkFlowSettingFormData.lists;
    const map: { [key: string]: string } = {
      'inPolicyApproverIDL1': 'inPolicyApproverName1',
      'inPolicyApproverIDL2': 'inPolicyApproverName2',
      'inPolicyApproverIDL3': 'inPolicyApproverName3',
      'outPolicyApproverIDL1': 'outPolicyApproverName1',
      'outPolicyApproverIDL2': 'outPolicyApproverName2',
      'outPolicyApprover_DL3': 'outPolicyApproverName3'
    };
    const codeMap: { [key: string]: string } = {
      'inPolicyApproverIDL1': 'inPolicyApproverCode1',
      'inPolicyApproverIDL2': 'inPolicyApproverCode2',
      'inPolicyApproverIDL3': 'inPolicyApproverCode3',
      'outPolicyApproverIDL1': 'outPolicyApproverCode1',
      'outPolicyApproverIDL2': 'outPolicyApproverCode2',
      'outPolicyApprover_DL3': 'outPolicyApproverCode3'
    };
    const idMap: { [key: string]: string } = {
      'inPolicyApproverIDL1': 'inPolicyApproverIdL1',
      'inPolicyApproverIDL2': 'inPolicyApproverIdL2',
      'inPolicyApproverIDL3': 'inPolicyApproverIdL3',
      'outPolicyApproverIDL1': 'outPolicyApproverIdL1',
      'outPolicyApproverIDL2': 'outPolicyApproverIdL2',
      'outPolicyApprover_DL3': 'outPolicyApproverIdL3'
    };
    if (map[controlName]) {
      lists[map[controlName]] = userName;
    }
    if (codeMap[controlName]) {
      lists[codeMap[controlName]] = userCode || '';
    }
    if (idMap[controlName]) {
      lists[idMap[controlName]] = userId || '';
    }
  }

  fetchApprover(search: string) {
    const module = 'APPROVER';

    if (search.length < 3) {
      this.CorporateUsers = [];
      return;
    }

    this._CamService.getTravellerList(search, module).then((res) => {

      this.CorporateUsers = res?.data?.travelers ?? [];
      this.CorporateUsersList.push(...res?.data?.travelers);
      this.noItemFound = this.CorporateUsers.length === 0 ? 'No matching approver found.' : '';
    }).catch((error) => {
      console.error(error)
    });
  }


  clearCorporateUsers() {
    this.CorporateUsers = [];
  }



  onSave() {
    // GTM use
    this._ApprovalManagementService.approval_menu_click('Approval flow settings');
    const selectedUsers = this.approvalflowForm.value.flag == 'UPDATE' ? this.CorporateUsers : this.CorporateUsersList;
    this._ApprovalManagementService.approval_save('Save', this.approvalflowForm.value, selectedUsers)
    if (this.approvalflowForm.invalid) {
      return
    }


    const formValue = this.approvalflowForm.value;
    //gtm use
    const gtmPayload = {
      formData: {
        form: formValue,
        lists: this.receivedData?.lists || this.approvalList || {}
      }
    };

    this._ApprovalManagementService.workflow_next(gtmPayload, 'Save');

    const payload: ApprovalFlowRequest = {
      ...formValue,
      inPolicyApproverIDL1: formValue.inPolicyApproverIDL1 || 0,
      inPolicyApproverIDL2: formValue.inPolicyApproverIDL2 || 0,
      inPolicyApproverIDL3: formValue.inPolicyApproverIDL3 || 0,
      outPolicyApproverIDL1: formValue.outPolicyApproverIDL1 || 0,
      outPolicyApproverIDL2: formValue.outPolicyApproverIDL2 || 0,
      outPolicyApprover_DL3: formValue.outPolicyApprover_DL3 || 0,
      totalApprovals: formValue.totalApprovals.toString(),
      travelCategory: formValue.travelCategory.toString(),
      workFlowAppliedOn: formValue.workFlowAppliedOn.toString() // Convert to string
    };

    this._CamService.insertUpdateApprovalManagementV1(payload).then((res) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Approval workflow created successfully.');
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || this.dictionaryContent?.['b2b.insertupdateapprovalflow.200success'] || 'Approval workflow updated successfully.');
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          break;
      }

      this._CamService.approvalWorkFlowSettingFormData = null;
      this._ApprovalManagementService.approvalSaveConfiguration('Save', 'Approval flow form');
      this.router.navigate(['/cam/approval-management/approval-listing'])


    }).catch((error) => {
      console.error(error);
      const statusCode = error?.status || '404';
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the Approval workflow. Please try again later.';

      this._ToastrApiService.show('error', errorMessage);
      this._ApprovalManagementService.errorMessage(error?.error?.message, error?.error?.errorCode || statusCode, 'Approval flow form');
    })


  }

  formatUserName(user: any): string {
    if (user && user.UserName) {
      const name = user.UserName.split('(')[0].trim();
      return name;
    }
    return '';
  }



  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

  extractName(fullString: string): string {
    return fullString.split('(')[0].trim(); // Extract name before '('
  }

  extractEmail(fullString: string): string {
    const emailMatch = fullString.match(/\((.*?)\)/);
    return emailMatch ? emailMatch[1] : ''; // Extract email inside '()'
  }

  formatSelectedUser(userId: string): string {
    if (!userId) return '';

    const user = this.CorporateUsers.find(u => u.UserId === userId);
    if (user) {
      const name = this.extractName(user.UserName);
      return `${name} - ${user.UserId}`;
    }
    return '';
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}